/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import {
  propTypesAltLanguage,
  propTypesIllustration,
  propTypesLink,
  propTypesTextHtml,
} from '../../shared/constants/Proptypes';

export const propTypesTag = {
  alternate_languages: PropTypes.arrayOf(PropTypes.shape(propTypesAltLanguage)),
  data: PropTypes.shape({
    breadcrumb_title: PropTypes.string,
    description: PropTypes.string,
    illustration: PropTypes.shape(propTypesIllustration),
    meta_description: PropTypes.string,
    meta_title: PropTypes.string,
    og_description: PropTypes.string,
    promo_card_illustration: PropTypes.shape(propTypesIllustration),
    promo_card_label: PropTypes.string,
    promo_card_link: PropTypes.shape(propTypesLink),
    promo_card_title: PropTypes.string,
    tag_name: PropTypes.string,
    title: PropTypes.shape(propTypesTextHtml),
  }),
  first_publication_date: PropTypes.string,
  lang: PropTypes.string,
  last_publication_date: PropTypes.string,
  prismicId: PropTypes.string,
  type: PropTypes.string,
  uid: PropTypes.string,
  url: PropTypes.string,
};
